import AttachmentOutlinedIcon from '@mui/icons-material/AttachmentOutlined';
import { downloadAuthed } from 'api/download';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const formatBytes = (value) => {
  const n = Number(value || 0);
  if (!n) return '0 B';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
};

const AdminCaseEvidencePage = () => {
  return (
    <AdminResourceCrudPage
      title="Case Evidence"
      subtitle="Review uploaded attachments linked to remediation cases."
      icon={AttachmentOutlinedIcon}
      endpoint="/api/admin/case-evidence/"
      allowCreate={false}
      allowEdit={false}
      allowDelete={false}
      columns={[
        { key: 'created_at', label: 'Uploaded', render: (row) => new Date(row.created_at).toLocaleString() },
        { key: 'case_title', label: 'Case' },
        { key: 'label', label: 'Label' },
        { key: 'uploaded_by_email', label: 'Uploaded By' },
        { key: 'size_bytes', label: 'Size', render: (row) => formatBytes(row.size_bytes) },
        { key: 'content_type', label: 'Content-Type' },
        { key: 'checksum', label: 'Checksum', render: (row) => (row.checksum ? `${row.checksum.slice(0, 16)}…` : '-') }
      ]}
      rowActions={[
        {
          label: 'Download',
          icon: DownloadOutlinedIcon,
          visible: (row) => Boolean(row.download_url),
          onClick: async (row) => {
            if (row.download_url) downloadAuthed(row.download_url).catch((err) => window.alert(err.message));
          }
        }
      ]}
    />
  );
};

export default AdminCaseEvidencePage;
